import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import {
  AnnouncementModal,
  AnnouncementList,
  AnnouncementListDetails,
  AnnouncementListingQueryParameters,
  AnnouncementFilter,
} from "./types";

export const announcementInitialstate: AnnouncementModal = {
  announcementList: {
    data: [],
    total: 0,
    pageNo: 0,
    totalPage: 0,
    nextHit: 0,
    limit: 0,
  },
  announcementDetails: {
    _id: "",
    subject: "",
    description: "",
    image: "",
    isArchived: false,
    publishStatus: "",
    scheduledDateTime: "",
    sentDate: "",
    status: "",
    created: 0,
    createdAt: "",
    updatedAt: "",
    addedBy: "",
  },

  announcementListingQueryParameters: {
    pageNo: 1,
    limit: 10,
    searchText: "",
  },

  announcementFilter: {
    publishStatus: [],
    toScheduledDate: null,
    fromScheduledDate: null,
    fromSentDate: null,
    toSentDate: null,
    fromAddedOnDate: null,
    toAddedOnDate: null,
    isArchived: false,
  },

  dateRangeForScheduled: undefined,
  dateRangeForSent: undefined,
  dateRangeForAddedOn: undefined,
};
const AnnouncementModuleSlice = createSlice({
  name: "announcement",
  initialState: announcementInitialstate,
  reducers: {
    setAnnouncementListingData: (
      state: AnnouncementModal,
      action: PayloadAction<AnnouncementList>,
    ) => {
      state.announcementList = { ...action.payload };
    },
    setAnnouncementDetails: (
      state: AnnouncementModal,
      action: PayloadAction<AnnouncementListDetails>,
    ) => {
      state.announcementDetails = action.payload;
    },
    setAnnouncementListingQueryParameters: (
      state: AnnouncementModal,
      action: PayloadAction<AnnouncementListingQueryParameters>,
    ) => {
      state.announcementListingQueryParameters = { ...action.payload };
    },

    setAnnouncementFilter: (
      state: AnnouncementModal,
      action: PayloadAction<AnnouncementFilter>,
    ) => {
      state.announcementFilter = action.payload;
    },
    setDateRangeForScheduled: (
      state: AnnouncementModal,
      action: PayloadAction<[Date, Date] | undefined>,
    ) => {
      state.dateRangeForScheduled = action.payload;
    },
    setDateRangeForSent: (
      state: AnnouncementModal,
      action: PayloadAction<[Date, Date] | undefined>,
    ) => {
      state.dateRangeForSent = action.payload;
    },
    setDateRangeForAddedOn: (
      state: AnnouncementModal,
      action: PayloadAction<[Date, Date] | undefined>,
    ) => {
      state.dateRangeForAddedOn = action.payload;
    },
  },
});

export const {
  setAnnouncementListingData,
  setAnnouncementDetails,
  setAnnouncementFilter,
  setAnnouncementListingQueryParameters,
  setDateRangeForAddedOn,
  setDateRangeForSent,
  setDateRangeForScheduled,
} = AnnouncementModuleSlice.actions;
export default AnnouncementModuleSlice.reducer;
